import { render, staticRenderFns } from "./OrderPurchase.vue?vue&type=template&id=3d0012de&scoped=true"
import script from "./OrderPurchase.vue?vue&type=script&lang=js"
export * from "./OrderPurchase.vue?vue&type=script&lang=js"
import style0 from "./OrderPurchase.vue?vue&type=style&index=0&id=3d0012de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0012de",
  null
  
)

export default component.exports